import React, { useEffect, useState } from 'react'
import './style.css'
import logoImage from '../../../assets/instagram-logo.png'
import axios from 'axios'

const enText = require('../../../utils/footerEnglishTexts.js')
const faText = require('../../../utils/footerFarsiTexts.js')

function FooterFa(props) {

  const [footerText,setFooterText] = useState(faText)
  const [countryCode, setCountryCode] = useState([])

  return (
      <footer>
        <div className='footer-container'>
          <div className='footer-container-right'>
            <h1>{footerText[0]}</h1>
            {/* <p>{footerText[1]}</p> */}
            <p>کدپستی: ۱۳۴۶۸۷۷۱۴۱</p>
            {/* <p>{footerText[2]}</p> */}
            <p>شماره تماس: ۶۶۳۵۰۴۸۸-۰۲۱</p>
            {/* <p>{footerText[3]}</p> */}
            <p>{"تهران، سلسبیل جنوبی، خیابان رودکی، کوچه شهید سیدعلی بهرامی، پلاک ۳۱، طبقه همکف، واحد غربی"}</p>
          </div>
          <div className='footer-container-left'>
            <a className='adress-mehrobo-instagram' href='https://www.instagram.com/mehroboo'>
              <p>mehroboo</p>
              <img src={logoImage}></img>
            </a>
            <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=359393&amp;Code=2RHIM4PDuWibpI89hppi"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=359393&amp;Code=2RHIM4PDuWibpI89hppi" alt="" style={{cursor: 'pointer'}} id="2RHIM4PDuWibpI89hppi"></img></a>
          </div>
        </div>
        <div className='section-all-rights-reserved'>
          <p>{footerText[4]}</p>
        </div>
      </footer>
  )
}

export default FooterFa